var Ng2FileInputOptions = (function () {
    function Ng2FileInputOptions() {
        this.dropText = "Drop file here";
        this.browseText = "Browse";
        this.removeText = "Remove";
        this.invalidFileText = "You have picked an invalid or disallowed file.";
        this.invalidFileTimeout = 8000;
        this.removable = true;
        this.multiple = false;
        this.accept = '';
        this.showPreviews = true;
        this.extensions = [];
    }
    return Ng2FileInputOptions;
}());
export { Ng2FileInputOptions };
//# sourceMappingURL=ng2-file-input-options.class.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-file-input/dist/src/ng2-file-input-options.class.js
// module id = ./node_modules/ng2-file-input/dist/src/ng2-file-input-options.class.js
// module chunks = vendor